import { HTTP_TOKEN } from "./http";

export const getNotification = filters => {
  return HTTP_TOKEN.get("notifications", { params: filters }).then(result => {
    return result.data;
  });
};

export const makeReadNotification = (notificationId) => {
  return HTTP_TOKEN.put(`notifications/${notificationId}`).then(result => {
    return result.data;
  });
};
